import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTbSev = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 30,
	height: 30,
	viewBox: "0 0 30 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M14.2282 1.31287C14.4368 0.895712 15.0321 0.895712 15.2406 1.31287L22.3672 15.566C22.5069 15.8456 22.3936 16.1855 22.1141 16.3253L20.0892 17.3378C19.8096 17.4775 19.4696 17.3642 19.3298 17.0846L15.2406 8.90622C15.0321 8.48907 14.4368 8.48907 14.2282 8.90622L10.1389 17.0846C9.99923 17.3642 9.65918 17.4775 9.37965 17.3378L7.35479 16.3253C7.07512 16.1855 6.96182 15.8456 7.10165 15.566L14.2282 1.31287Z",
		fill: "#FF3844"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M14.4813 10.8527C14.5856 10.6441 14.8833 10.6441 14.9876 10.8527L22.151 25.1797H26.9029C27.2155 25.1797 27.4689 25.4331 27.4689 25.7456V28.0095C27.4689 28.3221 27.2155 28.5755 26.9029 28.5755H20.4021C20.1878 28.5755 19.9917 28.4544 19.8958 28.2627L14.7344 17.9398L9.5731 28.2627C9.4772 28.4544 9.28113 28.5755 9.06681 28.5755H2.56598C2.25342 28.5755 2 28.3221 2 28.0095V25.7456C2 25.4331 2.25342 25.1797 2.56598 25.1797H7.3179L14.4813 10.8527Z",
		fill: "#FF3844"
	})]
});
export default SvgTbSev;
